import { render, staticRenderFns } from "./StaffPayroll.vue?vue&type=template&id=995e95ee&scoped=true&"
import script from "./StaffPayroll.vue?vue&type=script&lang=js&"
export * from "./StaffPayroll.vue?vue&type=script&lang=js&"
import style0 from "./StaffPayroll.vue?vue&type=style&index=0&id=995e95ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995e95ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSelect,VSpacer})
